<template>
  <section class="buttons">
    <button
      id="clear"
      type="button"
      name="clear"
      class="visualization__control-button"
      @click="resetData"
    >
      Clear
    </button>
    <!-- <button
      id="export-img"
      type="button"
      name="export-img"
      class="visualization__control-button"
      @click="exportImage"
    >
      Export Image
    </button> -->
    <button
      id="export"
      type="button"
      name="export"
      value="Export CSV"
      class="visualization__control-button"
      @click="exportCsv"
    >
      Export CSV
    </button>
    <i
      id="exportSpinner"
      class="fa fa-spinner fa-spin"
      style="display: none"
    ></i>
  </section>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import filesaver from "file-saver";

const { mapActions } = createNamespacedHelpers("visualization");

export default {
  methods: {
    ...mapActions(["updateChartData", "resetVisualization"]),

    resetData() {
      this.$emit("reset");
      this.resetVisualization();
    },

    // exportImage() {
    //   const canvas = document.getElementsByTagName("canvas")[0];
    //   canvas.toBlob(blob => {
    //     filesaver.saveAs(blob, "chart.png");
    //   });
    // },

    exportCsv() {
      this.$emit("export");
    },
  },
};
</script>

<style lang="scss">
.buttons {
  margin-top: 2rem;
  // margin-left: 0;
  // @include tablet() {
  //   margin-left: 1rem;
  // }
  padding-bottom: 1rem;
}
</style>
